var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 64,
    height: 64,
    viewBox: "0 0 172 172",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 83.30981,
    y1: 43,
    x2: 83.30981,
    y2: 148.73163,
    gradientUnits: "userSpaceOnUse",
    id: "color-1_52539_gr1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dd6e6e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 86,
    y1: 13.4375,
    x2: 86,
    y2: 159.01131,
    gradientUnits: "userSpaceOnUse",
    id: "color-2_52539_gr2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f61c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b12a2a"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,172v-172h172v172z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.209,150.51881c-0.00806,-0.989 -0.01613,-5.27287 -0.02419,-9.28262l-0.00806,-4.16563c-18.08419,2.45906 -22.46212,-10.15875 -22.5105,-10.29312c-2.51012,-6.364 -5.94206,-8.18344 -6.08987,-8.25869l-0.33325,-0.1935c-1.24431,-0.84925 -4.54456,-3.10944 -3.60663,-6.08181c0.84656,-2.67944 4.128,-2.95625 5.61956,-2.90788c8.26138,0.57781 12.44312,8.00338 12.61512,8.31781c4.21669,7.22669 10.65325,6.47956 14.80544,4.95575c0.387,-1.849 0.98631,-3.5475 1.77106,-5.04713c-13.31925,-2.36231 -28.40956,-9.44656 -28.40956,-35.217c0,-7.07619 2.20375,-13.33 6.56019,-18.62169c-0.97287,-3.24113 -2.08013,-9.85238 1.19862,-18.18094l0.46762,-1.18787l1.21475,-0.387c1.118,-0.36819 7.224,-1.677 19.77731,6.53869c5.1815,-1.32762 10.66669,-2.01294 16.32387,-2.03981c5.68406,0.02688 11.17463,0.71219 16.36687,2.03981c12.54256,-8.21837 18.63512,-6.89344 19.75581,-6.53869l1.21206,0.38969l0.46762,1.1825c3.29219,8.32587 2.18494,14.93981 1.21206,18.18363c4.34838,5.27556 6.55213,11.53206 6.55213,18.62169c0,25.77581 -15.10644,32.83856 -28.45525,35.17131c1.51306,2.86219 2.33275,6.45538 2.33275,10.42212c0,4.52306 -0.01881,19.36075 -0.04031,22.58038l-5.375,-0.03763c0.0215,-3.21425 0.04031,-18.02775 0.04031,-22.54544c0,-6.56288 -2.53431,-9.46537 -3.62813,-10.41138l-4.64937,-4.02319l6.11137,-0.67994c13.98844,-1.55338 28.28594,-6.39356 28.28594,-30.47894c0,-6.26188 -2.08819,-11.72019 -6.20813,-16.22175l-1.15563,-1.26044l0.65037,-1.57756c0.44612,-1.07769 2.40262,-6.56287 -0.11556,-14.21956c-2.03713,0.12094 -6.9015,1.08038 -15.007,6.57631l-1.032,0.69606l-1.19594,-0.33056c-5.00681,-1.39212 -10.58338,-2.13925 -16.12769,-2.16613c-5.51475,0.02688 -11.08325,0.774 -16.082,2.16613l-1.19594,0.33056l-1.02931,-0.69606c-8.11356,-5.49325 -12.98869,-6.46075 -15.03388,-6.58169c-2.51281,7.66206 -0.55362,13.14725 -0.1075,14.22494l0.65037,1.57756l-1.15294,1.26044c-4.128,4.51769 -6.21887,9.976 -6.21887,16.22175c0,24.07462 14.27062,28.94438 28.2295,30.53269l6.05225,0.688l-4.59025,4.00438c-0.99975,0.87344 -2.76812,2.9885 -3.37013,7.32881l-0.20156,1.47544l-1.35988,0.61006c-3.55019,1.591 -15.69231,5.81038 -22.97275,-6.67844c-0.04031,-0.06719 -1.462,-2.53969 -4.03662,-4.18444c1.73613,1.71731 3.85119,4.49619 5.55775,8.83381c0.17737,0.51062 3.64694,9.73412 19.565,6.28606l3.24112,-0.70413l0.03225,10.69088c0.00806,3.99631 0.01612,8.26675 0.02419,9.25575z",
    fill: "url(#color-1_52539_gr1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86,155.875c-38.53069,0 -69.875,-31.34431 -69.875,-69.875c0,-38.53069 31.34431,-69.875 69.875,-69.875c38.53069,0 69.875,31.34431 69.875,69.875c0,38.53069 -31.34431,69.875 -69.875,69.875zM86,21.5c-35.56369,0 -64.5,28.93631 -64.5,64.5c0,35.56369 28.93631,64.5 64.5,64.5c35.56369,0 64.5,-28.93631 64.5,-64.5c0,-35.56369 -28.93631,-64.5 -64.5,-64.5z",
    fill: "url(#color-2_52539_gr2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.ffccfb7e4586c742549713a19d440246.svg";
export { ForwardRef as ReactComponent };